import React from "react";
import { Transition, TransitionStatus } from "react-transition-group";

import { BASE_Z_INDEX } from "../Modal";

const TRANSITION_STYLES: Record<TransitionStatus, { opacity: number }> = {
  entered: { opacity: 1 },
  entering: { opacity: 1 },
  exited: { opacity: 0 },
  exiting: { opacity: 0 },
  unmounted: { opacity: 0 },
};

const Background: React.FC<{ inProp: boolean }> = ({ inProp }) => (
  <>
    <Transition in={inProp} timeout={300}>
      {(state) => (
        <div
          className="modal-background"
          data-testid="modal-background"
          style={TRANSITION_STYLES[state]}
        ></div>
      )}
    </Transition>
    <style jsx>{`
      .modal-background {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        transition: opacity 300ms ease-in-out;
        opacity: 0;
        background-color: rgba(0, 0, 0, 0.7);
        pointer-events: none;
        z-index: ${BASE_Z_INDEX - 1};
      }
    `}</style>
  </>
);

export default Background;
